import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { isEntitlementsPayload } from "@/lib/entitlements";

// "Il mio piano" (P3). Con ENTITLEMENTS_OWNER_UI_ENABLED spento il backend risponde 404: la UI
// non mostra nulla di nuovo (nessun lucchetto, nessuna voce di menu). Nessun errore all'utente.
export function useEntitlements({ enabled = true } = {}) {
  const q = useQuery({
    queryKey: ["entitlements", "me"],
    enabled,
    retry: false,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      try {
        const { data } = await api.get("/entitlements/me");
        return isEntitlementsPayload(data) ? data : null;
      } catch {
        return null;
      }
    },
  });
  useEffect(() => {
    if (!enabled) return undefined;
    const onBlock = () => { q.refetch(); };
    window.addEventListener("aiposto:plan-block", onBlock);
    return () => window.removeEventListener("aiposto:plan-block", onBlock);
  }, [enabled, q.refetch]); // eslint-disable-line react-hooks/exhaustive-deps
  const data = q.data || null;
  return { loading: q.isLoading, available: !!data, data, refetch: q.refetch };
}
